import Vue from 'vue'
import _axios from '@/assets/utils/_axios'
import Router from 'vue-router'
import PublicRouter from './Public.js'
import RegisterRouter from './Register.js'
import UserCenterRouter from './UserCenter.js'
import HomePage from './HomePage.js'
import {isInArray} from '../assets/utils/GlobalFunction'
import { async } from 'q';

Vue.use(Router)

//不登录就可以访问的白名单
const passRoute = ['adminLogin','register','index_page','userLogin'];

const router = new Router({
  mode: 'history',
  // 跳转到下一个页面的顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    ...PublicRouter,
    ...RegisterRouter,
    ...UserCenterRouter,
    ...HomePage,
  ]
});

//解决Loading chunk (\d)+ failed问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload();
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
});
/*路由拦截控制函数*/
const routerIntercept = (to, from, next) => {
  let userMessage = JSON.parse(window.localStorage.getItem('userLoginMessage')) || {};
  let toPath = to.path.match(/\w+/);
  let isAdmin = userMessage.socketType === 'admin',             //管理员身份
      isGroup = Number(userMessage.level)==1||Number(userMessage.level)==2,          //企业身份
      status = userMessage.status ? Number(userMessage.status) : 0,                  //门店认证状态
      isVerified = userMessage.status == 1,                                          //门店注册成功状态
      openId = userMessage.is_wechat_follow==0,                                      //门店的微信绑定情况
      isLogin  = userMessage.token;
  //如果未匹配到路由,上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  if (to.matched.length === 0) {
    from.name ? next({ name:from.name }) : next('/')
  }
  if (isLogin && !toPath) {                                  
    if (openId) { next('/register/wechat'); return  }
    //供应商-销售、登录跳转主页或关联页面
    if ((status == 2||status == 3)&&type==3) { next({ name: 'regBasicClose' }); return }
    //采购商跳转填写门店信息 
    if (status == 2&&userType==2) { next({ name: 'resBasicInfo' }); return }
    //采购商跳转填写门店信息 
    // if (status === 2) { next({ name: 'regVerify' }); return }
    //已登录情况下访问登录页自动进行跳转
    if (isAdmin || isGroup|| isVerified) { next('/userCenter'); return }
  }
  if (!isLogin && toPath && !isInArray(passRoute,toPath[0])) {      //未登录情况下访问非注册页时跳转到首页
    // next('/'); return
  }
  next();
};

/*全局路由控制*/
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) document.title = to.meta.title;
    // 已登录
    const userLoginMessage =  JSON.parse(window.localStorage.getItem('userLoginMessage') )|| '';
    if (userLoginMessage.token) {
    if (to.path === '/userLogin'||to.path === '/adminLogin'||to.path === '/enterpriseLogin'||to.path === '/trip') {
      // 想去登录页 → 强制跳回个人中心
      //如果是酒店注册用户返回加入酒店页面
      if (userLoginMessage.type == 3&&userLoginMessage.status == 2) {
        next('/register/basic-close')
      }else{
        next('/userCenter')
      }
    } else {
      next()
    }
  } else {
      // 未登录
      next()
    }
  /*路由验证拦截*/
  routerIntercept(to, from, next);
});

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
export default router;
